<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="标题 :" prop="title">
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="创建时间 :" prop="title">
              <el-date-picker v-model="time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                start-placeholder="开始时间" @change="timeChange" end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate('add')">
            <svg-icon icon-class="add" />&nbsp;发布
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }"
          :data="tableData" :cell-class-name="(item)=>{ if(item.columnIndex==1) return 'g-column-light-box'}">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="标题" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn" @click="goDetail(scope.row)">{{ scope.row.title }}</a>
              <!-- <router-link class="m-btn" target="_blank"
                :to="{path: '/approve/notice-detail', query: {obj:encodeURIComponent(JSON.stringify(scope.row))}}">{{ scope.row.title }}</router-link> -->
            </template>
          </el-table-column>
          <el-table-column prop="createTimeStr" label="创建时间" min-width="15%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTimeStr, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createrName" label="创建人" min-width="14%"></el-table-column>
          <el-table-column prop="statusName" label="发布状态" min-width="14%"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="15%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleTop(scope.row)">{{scope.row.top === '1' ? '取消置顶' : '置顶'}}</a>

              <a class="m-btn mr-10" @click="handlePublish(scope.row)">{{scope.row.status === '2' ? '取消发布' : '发布'}}</a>

              <a class="m-btn mr-10" @click="handleCreate('edit', scope.row.id)" v-if="scope.row.status != '2'">编辑</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogCreateInfo ref="dialogCreateInfo" @refresh="restList"></dialogCreateInfo>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogCreateInfo from './dialog-create-notice'
export default {
  components: {
    cmpMyExport,
    dialogCreateInfo
  },
  data() {
    return {
      form: {
        title: '',
        dateStart: '',
        dateEnd: ''
      },
      time: [],

      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      typeList: [],
      tableData: [],
      listLoading: true,
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      // 信息发布列表
      this.$http.get('/bsNoticeWeb/list', {
        ...this.listQuery,
        ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          this.tableData = res.result
          this.total = res.page.allRow
        }
      })
    },

    goDetail(obj) {
      if (obj.fileIds) {
        location.href = obj.fileList[0].attPath
      } else {
        const routeUrl = this.$router.resolve({
          path: '/approve/notice-detail',
          query: { obj: encodeURIComponent(JSON.stringify(obj)) }
        })

        window.open(routeUrl.href, '_blank')

      }
    },


    timeChange(arr) {
      if (!arr) {
        this.form.dateStart = ""
        this.form.dateEnd = ""
      } else {
        this.form.dateStart = arr[0]
        this.form.dateEnd = arr[1]
      }
    },



    // 重置查询
    restList() {
      this.time = []
      this.form.dateStart = ''
      this.form.dateEnd = ''

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },
    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '删除通知公告',
          content: '该通知公告将被删除，请谨慎操作'
        },
        () => {
          this.$http
            .post('/bsNoticeWeb/delete', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('通知公告删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handleTop(item) {
      this.$http
        .post('/bsNoticeWeb/topOrNot', {
          id: item.id,
          top: item.top == '1' ? '0' : '1'
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handlePublish(item) {
      this.$http
        .post('/bsNoticeWeb/publicOrNot', {
          id: item.id,
          status: item.status === '2' ? '1' : '2', // 1-取消发布 2-发布
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleCreate(type, id) {
      this.$refs.dialogCreateInfo.init(type, id)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
</style>